import * as React from 'react';
import * as styles from 'components/common/OrderForm/styles.scss';
import { Fallback, Modal } from 'components/common';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { Link } from 'react-router-dom';
import { AccountRoutes, Routes } from 'constants/routes';

interface IConfirmDebtModalProps
  extends React.ClassAttributes<ConfirmDebtModalComponent>,
    WithNamespaces {
  readonly isConfirmDebt?: boolean;
  readonly onCloseModalConfirmDebt?: () => void;
}

class ConfirmDebtModalComponent extends React.Component<
  IConfirmDebtModalProps
> {
  constructor(props: IConfirmDebtModalProps) {
    super(props);
  }
  render() {
    const { t, isConfirmDebt, onCloseModalConfirmDebt } = this.props;
    return (
      <>
        <Modal
          className={styles.ConfirmDebtModal}
          show={isConfirmDebt}
          onHide={onCloseModalConfirmDebt}
          size={'sm'}
        >
          <div className={styles.Title}>{t('Confirm Debt')}</div>
          <span>{t('Please confirm your debt to continue')}</span>
          <div className={styles.Buttons}>
            <button
              className={styles.CancelButton}
              onClick={onCloseModalConfirmDebt}
            >
              {t('Cancel')}
            </button>
            <Link
              to={`/${Routes.ACCOUNT}/${AccountRoutes.LOAN_DETAIL}`}
              className={styles.SubmitButton}
              onClick={onCloseModalConfirmDebt}
            >
              {t('Go to confirm debt')}
            </Link>
          </div>
        </Modal>
      </>
    );
  }
}

const ConfirmDebtModal = withErrorBoundary(
  withNamespaces('common')(connect()(ConfirmDebtModalComponent)),
  Fallback,
  handleError
);

export default ConfirmDebtModal;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/Modal/ConfirmDebtModal.tsx